import type { ReactNode } from 'react';
import { Icon } from '../../../ui/index.js';
import { useRequestItemPhotoUrl } from '../photoDownloadResolver.js';

function RequestListThumbnailFrame({ children }: { children?: ReactNode }) {
  return (
    <span
      data-testid="request-list-thumbnail"
      style={{
        width: 32,
        height: 32,
        flex: '0 0 32px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        borderRadius: 'var(--r-1)',
        border: '1px solid var(--border-2)',
        background: 'var(--bg-2)',
        color: 'var(--fg-3)',
      }}
    >
      {children ?? <Icon name="image" size={16} />}
    </span>
  );
}

export function RequestListThumbnailPlaceholder() {
  return <RequestListThumbnailFrame />;
}

export function RequestListThumbnail({
  requestId,
  itemId,
  objectKey,
}: {
  requestId: string;
  itemId: string;
  objectKey: string;
}) {
  const downloadUrl = useRequestItemPhotoUrl(requestId, itemId, objectKey);

  return (
    <RequestListThumbnailFrame>
      {downloadUrl ? (
        <img
          src={downloadUrl}
          alt=""
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      ) : (
        <Icon name="image" size={16} />
      )}
    </RequestListThumbnailFrame>
  );
}
